import { createFileRoute } from '@tanstack/react-router'
import { CREDIT_ROUTES, toStaticData } from '../../credit-route-config'

export const Route = createFileRoute('/_auth/_modules/credit/admin/roles')({
  staticData: toStaticData(CREDIT_ROUTES['/credit/admin/roles']),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
